module.exports = __webpack_public_path__ + "img/p3-right.16fe0445.svg";